import * as React from "react";
import {useEffect} from "react";

import firebase from "firebase/app";
import "firebase/storage";
import {frontEndConfig} from "src/config/config";
import {ConstColor} from "src/config/styles_const/styles_const";
import {IProjectRepository} from "src/domain/repository/project_repository";
import {createApiClient, IApiClient} from "src/infra/api/client";
import {createProjectAPI} from "src/infra/api/service/project_api";
import styled from "styled-components";
import {routeConfig} from "../../../../config/language/ja-JP/presentation/route_text";
import {Status} from "../../../../domain/model/project";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import {TBreadcrumbItem} from "../../../type/common";
import ClientProjectMainCreateForm, {SelectCoverImage,} from "./create/client_project_main_create_form";

const apiClient: IApiClient = createApiClient();
const projectRepository: IProjectRepository = createProjectAPI(apiClient);

interface IProps {
    handleCreateProjectSubmit: (values: any) => void;
}

const ClientProjectCreateComponent: React.FC<IProps> = (props) => {
    const {handleCreateProjectSubmit} = props;

    const params = {
        initialValues: {
            status: Status.Status_Draft,
        },
        onSubmit: handleCreateProjectSubmit,
    };

    const breadcrumbItems: TBreadcrumbItem[] = [
        routeConfig.clientRoot,
        routeConfig.clientProjects,
        routeConfig.clientProjectCreate,
    ];

    const [genProjectInfoModal, setGenProjectInfoModal] =
        React.useState<boolean>(false);
    const [generating, setGenerating] = React.useState<boolean>(false);
    const [requirements, setRequirements] = React.useState<string>("");
    const [generatedProjectInfo, setGeneratedProjectInfo] = React.useState<
        | {
        title: string;
        description: string;
        background: string;
        preferentialExperience: string;
    }
        | undefined
    >();
    const [selectedProjectInfo, setSelectedProjectInfo] = React.useState<
        | {
        description: string;
        background: string;
        preferentialExperience: string;
        name: string;
    }
        | undefined
    >();
    const [coverImage, setCoverImage] = React.useState<
        SelectCoverImage | undefined
    >();

    useEffect(() => {
        window.addEventListener("beforeunload", onUnload);

        return () => {
            window.removeEventListener("beforeunload", onUnload);
        };
    });

    const onUnload = (e: any) => {
        e.preventDefault();
        e.returnValue = "";
    };

    return (
        <React.Fragment>
            <PageWrapper>
                <div style={{maxWidth: 600, margin: "0 auto"}}>
                    <Breadcrumbs breadcrumbItems={breadcrumbItems}/>
                    {/*<PageTopInfo*/}
                    {/*  information={pageTopInfoConfig.clientProject}*/}
                    {/*  linkURL={OuterURL.clientProjectFaqURL}*/}
                    {/*/>*/}

                    <ClientProjectMainCreateForm
                        {...params}
                        formValues={{}}
                        enableReinitialize={true}
                        onGenerateProjectInfo={() => {
                            setGenProjectInfoModal(true);
                        }}
                        generatedProjectInfo={selectedProjectInfo}
                        onSelectCoverImage={async (i: number) => {
                            const gsURL = `gs://${frontEndConfig.projectId}.appspot.com/project-default-cover/cover${i}.png`;
                            const path = gsURL.replace("gs://", "");
                            const [bucket, ...filePathArray] = path.split("/");
                            const filePath = filePathArray.join("/");

                            const storage = firebase.storage();
                            const storageRef = storage.ref(filePath);
                            const httpURL = await storageRef.getDownloadURL();
                            setCoverImage({
                                gsUrl: gsURL,
                                httpUrl: httpURL,
                            });
                        }}
                        selectedCoverImage={coverImage}
                    />
                    {genProjectInfoModal && (
                        <OpenAIModal>
                            <OpenAIModalOuter>
                                <OpenAIModalInner>
                                    <OpenAIModalTitle>
                                        <OpenAIModalTitleBadge>新機能</OpenAIModalTitleBadge>
                                        <OpenAIModalTitleText>
                                            生成AIで案件情報の下書きを作成
                                        </OpenAIModalTitleText>
                                    </OpenAIModalTitle>

                                    <OpenAIModalDesc>
                                        <div>
                                            ✅ 入力された案件の概要をもとに、案件情報を作成します
                                            <br/>✅ 作成には30~60秒ほど時間がかかります
                                        </div>
                                        <div style={{color: "red"}}>
                                            🔎
                                            反映するボタンをクリックすると、元の案件情報が書き換わりますのでご注意ください。
                                            <br/>
                                            🔎
                                            必ず生成された内容を確認し、適切な内容に書き換えて反映を行ってください。
                                        </div>
                                    </OpenAIModalDesc>

                                    <textarea
                                        style={{
                                            lineHeight: "24px",
                                            fontSize: 16,
                                            color: "black",
                                            textAlign: "left",
                                            height: 150,
                                            width: 900,
                                            marginTop: 15,
                                            marginBottom: 15,
                                            padding: "10px 10px",
                                            resize: "none",
                                        }}
                                        value={requirements}
                                        placeholder={
                                            "作成したい案件の概要をご記載ください。\n（どのような課題を解決したいか、募集の背景は、どのような業務内容を想定しているか、どのような経歴や条件のエキスパートに入ってもらいたいか等）"
                                        }
                                        onChange={(e) => {
                                            setRequirements(e.target.value);
                                        }}
                                    />
                                    <OpenAIModalButtons>
                                        <OpenAIModalDoneButton
                                            isActive={!generating}
                                            onClick={() => {
                                                if (!requirements) {
                                                    return;
                                                }
                                                setGenerating(true);
                                                projectRepository
                                                    .generateProjectInfo(requirements)
                                                    .then((res) => {
                                                        setGenerating(false);
                                                        setGeneratedProjectInfo(res);
                                                    });
                                            }}
                                        >
                                            生成する
                                        </OpenAIModalDoneButton>
                                    </OpenAIModalButtons>

                                    <OpenAIModalLabel>案件名</OpenAIModalLabel>
                                    <OpenAIModalInput
                                        style={{height: 60}}
                                        isActive={
                                            generatedProjectInfo != null &&
                                            !!generatedProjectInfo.title
                                        }
                                    >
                                        {generating && (
                                            <>
                                                <Indicator style={{marginTop: 15, marginBottom: 15}}/>
                                            </>
                                        )}
                                        {generatedProjectInfo != null &&
                                            !!generatedProjectInfo.title && (
                                                <input
                                                    style={{
                                                        lineHeight: "24px",
                                                        fontSize: 16,
                                                        color: "black",
                                                        textAlign: "left",
                                                        width: 900,
                                                        padding: "10px 10px",
                                                    }}
                                                    value={generatedProjectInfo.title}
                                                    onChange={(e) => {
                                                        setGeneratedProjectInfo({
                                                            ...generatedProjectInfo,
                                                            title: e.target.value,
                                                        });
                                                    }}
                                                />
                                            )}
                                    </OpenAIModalInput>

                                    <OpenAIModalLabel>業務内容</OpenAIModalLabel>
                                    <OpenAIModalInput
                                        isActive={
                                            generatedProjectInfo != null &&
                                            !!generatedProjectInfo.description
                                        }
                                    >
                                        {generating && (
                                            <>
                                                <Indicator/>
                                            </>
                                        )}
                                        {generatedProjectInfo != null &&
                                            !!generatedProjectInfo.description && (
                                                <textarea
                                                    style={{
                                                        lineHeight: "24px",
                                                        fontSize: 16,
                                                        color: "black",
                                                        textAlign: "left",
                                                        height: 250,
                                                        width: 900,
                                                        overflowY: "scroll",
                                                        resize: "none",
                                                    }}
                                                    value={generatedProjectInfo.description}
                                                    placeholder="・医療系SaaSプロダクトの設計・開発におけるアドバイス提供\n
・プロダクトの仕様策定および改善提案\n
・ユーザーインターフェースおよびユーザーエクスペリエンスの最適化\n
・技術的な問題解決および技術選定の支援\n
・開発チームとの定期的なミーティングおよびフィードバックの提供"
                                                    onChange={(e) => {
                                                        setGeneratedProjectInfo({
                                                            ...generatedProjectInfo,
                                                            description: e.target.value,
                                                        });
                                                    }}
                                                />
                                            )}
                                    </OpenAIModalInput>

                                    <OpenAIModalLabel>募集背景</OpenAIModalLabel>
                                    <OpenAIModalInput
                                        isActive={
                                            generatedProjectInfo != null &&
                                            !!generatedProjectInfo.background
                                        }
                                    >
                                        {generating && (
                                            <>
                                                <Indicator/>
                                            </>
                                        )}
                                        {generatedProjectInfo != null &&
                                            !!generatedProjectInfo.background && (
                                                <textarea
                                                    style={{
                                                        lineHeight: "24px",
                                                        fontSize: 16,
                                                        color: "black",
                                                        textAlign: "left",
                                                        height: 250,
                                                        width: 900,
                                                        overflowY: "scroll",
                                                        resize: "none",
                                                    }}
                                                    value={generatedProjectInfo.background}
                                                    placeholder="弊社は医療系SaaSソリューションの提供を目指しており、新規プロダクトの設計・開発を進めています。この度、より専門性の高い知見を取り入れ、プロダクトの品質を向上させるため、経験豊富なプロダクト設計アドバイザーを募集することとなりました。医療業界の特有のニーズを理解し、最適なソリューションを提案できる方を求めています。"
                                                    onChange={(e) => {
                                                        setGeneratedProjectInfo({
                                                            ...generatedProjectInfo,
                                                            background: e.target.value,
                                                        });
                                                    }}
                                                />
                                            )}
                                    </OpenAIModalInput>

                                    <OpenAIModalLabel>求める経験</OpenAIModalLabel>
                                    <OpenAIModalInput
                                        isActive={
                                            generatedProjectInfo != null &&
                                            !!generatedProjectInfo.preferentialExperience
                                        }
                                    >
                                        {generating && (
                                            <>
                                                <Indicator/>
                                            </>
                                        )}
                                        {generatedProjectInfo != null &&
                                            !!generatedProjectInfo.preferentialExperience && (
                                                <textarea
                                                    style={{
                                                        lineHeight: "24px",
                                                        fontSize: 16,
                                                        color: "black",
                                                        textAlign: "left",
                                                        height: 250,
                                                        width: 900,
                                                        overflowY: "scroll",
                                                        resize: "none",
                                                    }}
                                                    value={generatedProjectInfo.preferentialExperience}
                                                    placeholder="・医療系SaaSプロダクトの設計・開発経験（5年以上）\n
・UX/UIデザインに関する知識と実務経験\n
・ソフトウェア開発における技術選定および問題解決の経験\n
・開発チームとの協働経験およびリーダーシップスキル"
                                                    onChange={(e) => {
                                                        setGeneratedProjectInfo({
                                                            ...generatedProjectInfo,
                                                            preferentialExperience: e.target.value,
                                                        });
                                                    }}
                                                />
                                            )}
                                    </OpenAIModalInput>

                                    <OpenAIModalButtons>
                                        <OpenAIModalCancelButton
                                            onClick={() => {
                                                setGeneratedProjectInfo(undefined);
                                                setSelectedProjectInfo(undefined);
                                                setGenProjectInfoModal(false);
                                            }}
                                        >
                                            キャンセル
                                        </OpenAIModalCancelButton>

                                        <OpenAIModalDoneButton
                                            isActive={generatedProjectInfo != null}
                                            onClick={() => {
                                                if (!generatedProjectInfo) {
                                                    return;
                                                }
                                                setGenProjectInfoModal(false);
                                                setSelectedProjectInfo({
                                                    name: generatedProjectInfo.title,
                                                    description: generatedProjectInfo.description,
                                                    background: generatedProjectInfo.background,
                                                    preferentialExperience:
                                                    generatedProjectInfo.preferentialExperience,
                                                });
                                                setGeneratedProjectInfo(undefined);
                                            }}
                                        >
                                            反映する
                                        </OpenAIModalDoneButton>
                                    </OpenAIModalButtons>
                                </OpenAIModalInner>
                            </OpenAIModalOuter>
                        </OpenAIModal>
                    )}
                </div>
            </PageWrapper>
        </React.Fragment>
    );
};

export default ClientProjectCreateComponent;

const OpenAIModal = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const OpenAIModalOuter = styled.div`
    width: 1000px;
    height: 600px
    overflow-y: scroll;
    border: 0.5px black solid;
    border-radius: 3px;
    box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.05);
    background-color: white;
`;

const OpenAIModalInner = styled.div`
    margin: 16px;
    text-align: center;
    vertical-align: middle;
    padding: 30px;
`;

const OpenAIModalTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;
const OpenAIModalTitleText = styled.div`
    display: inline-block;
    font-size: 20px;
    font-weight: bold;
`;
const OpenAIModalTitleBadge = styled.div`
    display: inline-block;
    display: inline-block;
    padding: 2px 4px;
    background-color: #00d58e;
    border-radius: 4px;
    color: white;
    font-size: 10px;
    font-weight: bold;
    margin-right: 15px;
`;

const OpenAIModalDesc = styled.div`
    width: 700px;
    margin: 0 auto;
    margin-top: 25px;
    margin-bottom: 25px;
    font-size: 16px;
    font-weight: normal;
    text-align: left;
    line-height: 25px;
`;

interface OpenAIModalInputProps {
    isActive: boolean;
}

const OpenAIModalInput = styled.div<OpenAIModalInputProps>`
    margin-top: 15px;
    margin-bottom: 15px;
    background-color: ${(props) => (props.isActive ? "white" : "#c4c4c4")};
    height: 250px;
    width: 900px;
    overflow-y: scroll;
`;

const OpenAIModalButtons = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

const OpenAIModalCancelButton = styled.div`
    padding: 10px 20px;
    border: 1px solid #d6d6d6;
    border-radius: 4px;
    margin-right: 15px;
    background-color: white;
    color: black;
    font-size: 12px;
    cursor: pointer;
`;

interface OpenAIModalDoneButtonProps {
    isActive: boolean;
}

const OpenAIModalDoneButton = styled.div<OpenAIModalDoneButtonProps>`
    padding: 10px 20px;
    border: 1px solid #d6d6d6;
    border-radius: 4px;
    background-color: ${(props) =>
            props.isActive ? ConstColor.Corporate : "#d6d6d6"};
    color: white;
    font-size: 12px;
    cursor: pointer;
`;

const Indicator = styled.div`
    width: 30px; /*ローディングアイコンの横サイズ*/
    height: 30px; /*ローディングアイコンの縦サイズ*/
    margin: 0 auto;
    margin-top: 100px;
    margin-bottom: 20px;
    border-radius: 50%; /*CSS3で円を書く*/
    border: 4px solid ${ConstColor.Corporate}; /*円に○の枠をつける*/
    border-right-color: transparent; /*円の右にC状の空きをつける*/
    animation: spin 1s linear infinite; /*1秒毎にくるくる回転するアニメーション*/
    @keyframes spin {
        /*0%の時は20％の透明度*/
        0% {
            transform: rotate(0deg);
            opacity: 0.2;
        }

        /*50%の時は透明度なし*/
        50% {
            transform: rotate(180deg);
            opacity: 1;
        }

        /*100%の時に20％の透明度に戻る*/
        100% {
            transform: rotate(360deg);
            opacity: 0.2;
        }
    }
`;

const OpenAIModalLabel = styled.div`
    font-size: 14px;
    font-weight: bold;
    width: 100%;
    text-align: left;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/project/client_project_create.tsx